var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as _ from "lodash";
import * as React from 'react';
import { styled } from '../theme/ThemeHelpers';
import { appendPx } from "../theme/DefaultTheme";
var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    display: grid;\n    display: -ms-grid;\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    display: grid;\n    display: -ms-grid;\n    ", "\n    ", "\n    ", "\n"])), function (props) { return props.floated ? "" : "width: 100%;"; }, function (props) { return props.floated ? "float: ".concat(props.floated, ";") : ""; }, function (props) {
    return props.spacing ?
        (props.vertical
            ? "grid-template-rows: ".concat(_.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" "), " 1fr;")
            : "grid-template-columns: ".concat(_.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" "), " 1fr;"))
        : (props.vertical
            ? "grid-template-rows: repeat(".concat(props.buttons, ", 1fr);")
            : "grid-template-columns: repeat(".concat(props.buttons, ", 1fr);"));
}, function (props) {
    return props.spacing ?
        (props.vertical
            ? "-ms-grid-rows: ".concat(_.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" "), " 1fr;")
            : "-ms-grid-columns: ".concat(_.times(props.buttons - 1, function (b) { return "1fr " + appendPx(props.spacing); }).join(" "), " 1fr;"))
        : (props.vertical
            ? "-ms-grid-rows: ".concat(_.times(props.buttons, function (b) { return "1fr "; }), ";")
            : "-ms-grid-columns: ".concat(_.times(props.buttons, function (b) { return "1fr "; }), ";"));
});
var ButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (props) { return props.floated ? "float: ".concat(props.floated, ";") : (props.spacing ?
    (props.vertical
        ? "grid-row-start: ".concat(props.pos * 2 - 1, "; -ms-grid-row: ").concat(props.pos * 2 - 1, ";")
        : "grid-column-start: ".concat(props.pos * 2 - 1, "; -ms-grid-column: ").concat(props.pos * 2 - 1, ";"))
    :
        (props.vertical
            ? "grid-row-start: ".concat(props.pos, "; -ms-grid-row: ").concat(props.pos, ";")
            : "grid-column-start: ".concat(props.pos, "; -ms-grid-column: ").concat(props.pos, ";"))); });
var ButtonGroup = React.memo(function (props) {
    var filtered = _.isArray(props.children) ? _.filter(props.children, function (c) {
        if (c)
            return true;
        return false;
    }) : undefined;
    var len = filtered ? filtered.length : 1;
    var children = props.children, fluid = props.fluid, spacing = props.spacing, vertical = props.vertical, floated = props.floated, width = props.width;
    var hasFloated = false;
    React.Children.forEach(children, function (c) { var _a; return hasFloated = hasFloated || ((_a = c === null || c === void 0 ? void 0 : c.props) === null || _a === void 0 ? void 0 : _a.floated) !== undefined; });
    var childs = React.useMemo(function () { return function () {
        return React.Children.map(filtered, function (c, i) {
            var _a;
            return (React.createElement(ButtonContainer, { pos: i + 1, key: i, vertical: vertical, spacing: spacing, floated: !fluid ? (_a = c === null || c === void 0 ? void 0 : c.props) === null || _a === void 0 ? void 0 : _a.floated : undefined }, React.cloneElement(c, { fluid: fluid ? fluid : true })));
        });
    }; }, [children, fluid, spacing, vertical]);
    return (React.createElement("div", { style: { width: width ? width : (floated || fluid || hasFloated ? "100%" : "fit-content") } }, (fluid || !hasFloated) ?
        React.createElement(ButtonGroupContainer, { buttons: len, vertical: vertical, spacing: spacing, floated: floated }, children && childs())
        :
            React.createElement(React.Fragment, null, children && childs())));
});
export default ButtonGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonGroup.js.map